<template>
    <div>
       <!-- 卷 -->
         <div class="volumes">
            <Row :gutter="10">
                <Col span="4">
                    <Button type="primary" @click="addModal()">{{ $t('configuration_management.customized_alarm_config.addVolume') }}</Button>
                </Col>
            </Row>
        </div>
        <Modal v-model="modal" :title="$t('configuration_management.customized_alarm_config.addVolume')" width="930px;" :loading="modalLoading" :mask-closable="false" :closable="false">
            <Form :model="volumeForm" :label-width="40" ref="volumeForm">
                <!-- 搜索 -->
                <Row :gutter="16">
                    <Col span="7">
                        <!-- 账户 -->
                        <FormItem :label="$t('permission_configuration_management.account.account')" prop="account">
                            <Select v-model="volumeForm.account" :placeholder="$t('resourceLifecycle.pleaseSelect')" @on-change="changeAccount(volumeForm.account)" :transfer="true">
                                <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="7">
                        <!-- 存储区域 -->
                        <FormItem :label="$t('permission_configuration_management.account.region')" prop="region">
                            <Select @on-change="changeRegion(volumeForm.region)" :placeholder="$t('resourceLifecycle.pleaseSelect')" v-model="volumeForm.region" :transfer="true" multiple :max-tag-count="1">
                                <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('configuration_management.customized_alarm_config.checkAll') }}</Checkbox>
                                <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <!-- 标签 -->
                        <FormItem :label="$t('alarms.common.tags')" prop="tags">
                            <Input v-model="volumeForm.tags" placeholder=""/>
                        </FormItem>
                    </Col>
                    <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchVolumesInput()">{{ $t('alarms.common.search') }}</Button>
                </Row>
                <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns" :loading="loading" :data="queryAccountVolumesData" :height="400" @on-selection-change="getSelection"></Table>
            </Form>
            <div slot="footer">
                <Button @click="handleReset('volumeForm')">{{ $t('RIAccountGroupManagement.cancel') }}</Button>
                <Button type="primary" @click="handleSubmit('volumeForm')" :loading="addloading" :disabled="isDisable">{{ $t('MCM.automaticalMaintenanceReport.add') }}</Button>
            </div>
        </Modal>
        <table-volumes></table-volumes>
    </div>
</template>

<script>
    import TableVolumes from '../ebs/TableVolumes'
    var tableVolumes = TableVolumes;
    export default {
        name: 'AddVolumes',
        components: {
            TableVolumes
        },
        data (){
            return {
                singleBackupRegion:false,
                volumeForm: {
                    account: '',
                    region: [],
                    tags: ''
                },
                accountList: [],
                regionList: [],
                selection:[],
                modal:false,
                isDisable: true,
                modalLoading: true,
                loading: false,
                isShowSearch: false,
                addloading:false,
                columns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('alarms.disk.name'),
                    key: 'name'
                },
                {
                    title: this.$t('RAM.AWS.computeInstance.instanceID'),
                    key: 'instanceId'
                },
                {
                    title: this.$t('alarms.disk.deviceName'),
                    key: 'deviceName'
                },
                {
                    title: this.$t('alarms.disk.diskId'),
                    key: 'volumeAwsId'
                },
                {
                    title: this.$t('alarms.disk.capacity'),
                    key: 'capacity'
                },
                {
                    title: this.$t('alarms.disk.type'),
                    key: 'type'
                },
                {
                    title: this.$t('alarms.disk.iops'),
                    key: 'iops'
                },
                 {
                    title: this.$t('alarms.disk.encrypted'),
                    key: 'encrypted'
                },
                {
                    title: this.$t('alarms.disk.region'),
                    key: 'region'
                },
                {
                    title: this.$t('alarms.disk.state'),
                    key: 'stateName'
                }],
                queryAccountVolumesData: [],
                newQueryAccountVolumesDataList:[]
            }
        },
        methods: {
            addModal:function(){
                this.modal=true;
                // 查询账户
                this.$api.account.selectAccountByCloudPlatform("type", this.$route.query.type)
                .then(res => {
                    this.accountList = res.data;
                })
            },
            // 切换账户
            changeAccount: function () {
                if (this.volumeForm.account == "" || this.volumeForm.account == null) {
                    return;
                }
                this.volumeForm.region = [];
                this.isShowSearch = true;
                this.$api.account.queryAccountRegions("accountId", this.volumeForm.account)
                    .then(res => {
                        this.regionList = res.data;
                    })
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.volumeForm.region = []
                if (this.singleBackupRegion) {
                    this.regionList.map((item) => {
                        this.volumeForm.region.push(item.name)
                    })
                } else {
                    this.volumeForm.region = []
                }
            },
            // 切换存储区域
            changeRegion: function (val) {
                if (val.length === this.regionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                this.queryAccountVolumesData = [];
                this.isShowSearch = true;
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryAccountVolumesDataList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableQueryAccountVolumesDataCopy = new Object();
                    TableQueryAccountVolumesDataCopy.ticketCompanyMonitorItemVariablesId=this.$route.query.id;
                    TableQueryAccountVolumesDataCopy.resourceId=this.selection[i].id;
                    TableQueryAccountVolumesDataCopy.resourceType=this.$route.query.monitorModule;
                    this.newQueryAccountVolumesDataList.push(TableQueryAccountVolumesDataCopy);
                }
                // 选了数据 可以点击下一步
                if (this.newQueryAccountVolumesDataList.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 点击查询
            searchVolumesInput: function () {
                if (this.volumeForm.account == "" || this.volumeForm.account == null || this.volumeForm.region == [] || this.volumeForm.region == null) {
                    return;
                }
                this.loading = true;
                // 根据AccountId查询卷列表
                this.$api.alertRuleExceptionResource.listNotExceptionResource({
                    "regions": this.volumeForm.region,
                    "accountId": this.volumeForm.account,
                    "monitorModule": this.$route.query.monitorModule,
                    "ticketCompanyMonitorItemVariablesId": this.$route.query.id
                }).then(res => {
                    this.queryAccountVolumesData = res.data;
                    this.loading = false;
                })
            },
            // 添加
            handleSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 增加
                        this.addloading=true;
                        this.$api.alertRuleExceptionResource.batchCreate({
                            "alertRuleExceptionResourceDTOS":this.newQueryAccountVolumesDataList
                        }).then(res => {
                            setTimeout(() => {
                                tableVolumes.methods.showAllVolume();
                                this.$refs[name].resetFields();
                                this.modalLoading = false;
                                this.$nextTick(() => {
                                    this.modalLoading = true;
                                });
                                this.$Message.success('添加成功');
                                this.queryAccountVolumesData=[];
                                this.newQueryAccountVolumesDataList=[];
                                this.modal = false;
                                this.addloading=false;
                                this.isDisable = true;
                                this.isShowSearch=false;
                            }, 1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.modalLoading = false;
                        setTimeout(() => {
                            this.modalLoading = true
                        }, 0)
                        this.$Message.error('添加失败');
                    }
                });

            },
             // 取消
            handleReset: function (name) {
                this.isDisable = true;
                this.modal = false;
                this.isShowSearch=false;
                this.queryAccountVolumesData=[];
                this.newQueryAccountVolumesDataList=[];
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>
    /*volumes*/
    .volumes
    {
        width: 100%;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/ebs/AddVolumes.vue